import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs/internal/Subscription";
import { User } from "src/app/main/model/auth/user.model";
import { UserService } from "src/app/main/services/auth/user.service";
import { VersionService } from "src/app/main/services/version/version.service";

export enum VersionUpdateActionEnum {
  Dismiss,
  Refresh,
  Snooze,
}

@Component({
  selector: "app-version-update-modal",
  templateUrl: "./version-update-modal.component.html",
  styleUrls: ["./version-update-modal.component.scss"],
})
export class VersionUpdateModalComponent implements OnInit, OnDestroy {
  currentUser: User | null = null; // current authenticated user
  forceUpdate: boolean = false; // if true, user must refresh to continue using the app
  private subscriptions: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService,
    private versionService: VersionService,
  ) {
    this.subscriptions = new Subscription();
  }

  ngOnInit() {
    // get current user
    this.subscriptions.add(
      this.userService.currentUserSubject.subscribe((user) => {
        if (!user) {
          return;
        }
        this.currentUser = user;
      }),
    );
    this.forceUpdate = this.versionService.forceUpdate;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  snooze() {
    this.activeModal.dismiss(VersionUpdateActionEnum.Snooze);
  }

  dismiss() {
    this.activeModal.dismiss(VersionUpdateActionEnum.Dismiss);
  }

  refreshPage() {
    this.activeModal.close(VersionUpdateActionEnum.Refresh);
    window.location.reload();
  }
}
